export const passwordValidationMessage = 'La contraseña debe tener al menos 5 caracteres, al menos una mayúscula, una minúscula y un número';
export const rucValidationMessage = 'Formato de RUC incorrecto';